import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { RenderRadioCheckBox } from '../../../component/formInput';

const selector = formValueSelector("ItemRenewModal")

class ItemRenewModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    }

  }

  // Gia Hạn Thủ Công.
  manualRenewService = () => {
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc sẽ gia hạn THỦ CÔNG dịch vụ này ?.");

    const { invoice_code, invoice_item_obj, addons, onHide } = this.props;

    const data = {
      invoice_item_id: invoice_item_obj.id,
      invoice_code: invoice_code,
      user_product_id: invoice_item_obj.user_product.id,
      renew_month: invoice_item_obj.month + invoice_item_obj.extra_month,
      addon_services: addons
    }

    if(alert_confirm) {
      // Block Page and waiting HTTP Response.
      this.setState({
        isLoading: true
      })
      axios({
        method: 'post',
        url: window.api_url + "/admin/api/setup/renew/invoice",
        withCredentials: true,
        data: data
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        if(!response.data.isError) {
          onHide();
        }else {
          toast.error(response.data.error);
        }
      });
    }
  }

  // Tự động gia hạn.
  autoRenewService = () => {
    const { product_type } = this.props;
    
    // SSL Gia hạn tự động
    if(product_type === "SSL") {
      this.sslAutoRenew();
    }
    
  }

  // SSL Gia hạn tự động.
  sslAutoRenew = () => {
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc sẽ gia hạn TỰ ĐỘNG dịch vụ SSL ?.");

    const { invoice_code, invoice_item_obj, onHide } = this.props;

    const data = {
      invoice_item_id: invoice_item_obj.id,
      invoice_code: invoice_code,
      user_product_id: invoice_item_obj.user_product.id,
      renew_month: invoice_item_obj.month + invoice_item_obj.extra_month,
    }

    if(alert_confirm) {
      // Block Page and waiting HTTP Response.
      this.setState({
        isLoading: true
      })
      axios({
        method: 'post',
        url: window.api_url + "/admin/api/ssl/auto_renew",
        withCredentials: true,
        data: data
      }).then(function (response) {
        self.setState({
          isLoading: false
        })
        if(!response.data.isError) {
          onHide();
        }else {
          toast.error(response.data.error);
        }
      });
    }

  }

  render() {
    const { isLoading } = this.state;
    const { handleSubmit, setupTypeSelected } = this.props;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, keyboard: false };
    
    const setup_type_options = [
      { label:"Gia hạn thủ công", value: "MANUAL_RENEW_SERVICE" },
      { label:"Gia hạn tự động", value:"AUTO_RENEW_SERVICE" }
    ];

    return (
      <div style={{ width: '30%' }}>
        <ToastContainer />
        <Modal
          {...modalConfig}
          aria-labelledby="contained-modal-title-lg">
          <Modal.Header closeButton={!isLoading && true}>
            <Modal.Title id="contained-modal-title-sm"><center>Gia Hạn Đơn Hàng</center> </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoading && <div>
                <img width="30" alt="tadu.cloud" src="/assets/img/squares.gif" />
            </div>}
            {!isLoading && <form  className="form-horizontal">
              <Field name="setup_type" options={setup_type_options} component={RenderRadioCheckBox} />
                {setupTypeSelected === "MANUAL_RENEW_SERVICE" && <button onClick={handleSubmit(this.manualRenewService)} type="submit" style={{margin: 5, float: 'right'}} className={"btn bg-orange btn-orange"}>
                    Gia hạn thủ công
                </button>}
                {setupTypeSelected === "AUTO_RENEW_SERVICE" && <button onClick={handleSubmit(this.autoRenewService)} type="submit" style={{margin: 5, float: 'right'}} className={"btn bg-success btn-success"}>
                    Gia hạn tự động
                </button>}
            </form>}
          </Modal.Body>
        </Modal>
      </div>
    )
  }
};
const mapState = (state, props) => ({
  userProfile: state.userProfile.data,
  setupTypeSelected: selector(state, "setup_type"),
});

const mapDispatch = dispatch => ({
  
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'ItemRenewModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
  })(withRouter(ItemRenewModal))));




